module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "cross-svgrepo-com.de6adeab.svg" + "?" + Date.now();